
























import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel2 } from "@/components";
import info from "./components/info.vue"
import specs from "./components/specs.vue"
@Component({
    components: {
        padHeadPanel2,info,specs
    },
})
export default class product extends Vue {

    active='spxx';

    userInfo = {};
   
    public $refs: {
    };
    isFromDetail= false;

    @Watch('$route')
    routeChange(to,from){
        this.isFromDetail = from.path=='/pad/product/viewProduct'?true:false;
    }
    created() {
    }
    activated() {
        this.active ='spxx';  
        if(this.$refs['info']&&!this.isFromDetail){
            this.$refs['info'].resetSearch();
        }
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }

    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson']?this.userInfo['authorityJson'].split(','):[];
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    deactivated(){
        if(this.$refs['info']){
            this.$refs['info'].clearListen();
        }
    }
    tabChange(val){
        console.log(val);
        if(val=='spgg'&&this.$refs['info']){
            this.$refs['info'].clearListen();
        }else{
            this.$refs['info'].addListen();
        }
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/product/product.vue